import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        // 模拟登录状态
        loginStatus: false,
        // loginStatus: true,
        // token  暂时写死受同源影响上线的时候记得重新获取
        // agency_id: 281,
        // token: "6203759d9c577d6d2e82adb5", //测试二612c766b3debf11a398d1eb5  测试一60d31f8290976243386beec5
        token: localStorage.getItem("token"), //测试二6119d91216fa232f0cc95f2e  测试一60d31f8290976243386beec5
        agency_id: localStorage.getItem("agency_id"),
        // agency_id: 281,
        // 首页打卡默认路由数据从index页面的请求中过来
        carDefaultRouter: '',
        // 用户ID以及用户头像
        MyuserInfo: {
            avatar: null
        },
        // // QA问答
        // qa: [],
        // 做题结算页是否未做题
        oneOpen: true,
        // 详情页面包屑导航内容
        detailMianbao: null,
        // 当前是否有文件下载列表
        fileList: null,
        // 是否有订单发货
        oderFlag: null,
        // 赠课列表
        giveClassList: null
    },
    mutations: {
        // 详情页面包屑导航内容
        mydetailMianbao(state, info) {
            state.detailMianbao = info
        },
        // 做题结算页做题判断
        myOneOpen(state, item) {
            state.oneOpen = item
            console.log(state.oneOpen)
        },
        //用于评论部分的详情评论的跳转
        newOpen(state, item) {
            let hash = window.location.origin + window.location.pathname + "#"
            window.open(hash + "/Detail/shareChild/" + item);
        },
        // 屏幕滚动函数
        scrollToTop(i) {
            console.log("运行了滚动函数" + i)
                // event为需要跳转的锚点元素ID，如果event为0则返回顶部
            var y = 0;
            let duration = 500;
            /*y:目标纵坐标,duration:时间(毫秒)*/
            var scrollTop = document.documentElement.scrollTop;
            /*页面当前滚动距离*/
            var distance =
                y - scrollTop; /*结果大于0,说明目标在下方,小于0,说明目标在上方*/
            var scrollCount = duration / 10; /*10毫秒滚动一次,计算滚动次数*/
            var everyDistance =
                distance / scrollCount; /*滚动距离除以滚动次数计算每次滚动距离*/
            for (
                var index = 1; index <= scrollCount; index++ /*循环设置scrollBy事件,在duration之内,完成滚动效果*/
            )
                setTimeout(function() {
                    window.scrollBy(0, everyDistance);
                }, 10 * index);
        },
        // VUE中的消息弹窗组件，这里第一个值为提示的内容，第二个值为提示框的标题，第三个值为确保在VUEX中使用VUE的方法而传过来的VUE中的this
        openMessage(state, data) {
            data.that.$alert(data.content, data.title, {
                confirmButtonText: '确定',
            });
        },
        // 从index router 中获取过来的数据存入VUEX 方便在默认跳转的时候跳转回用户当前操作页面
        getcardRouter(state, router) {
            state.carDefaultRouter = router
        },
        login(state, key) {
            if (key.token == null) {
                state.loginStatus = false
                state.agency_id = key.agency_id
                return
            } else {
                state.agency_id = key.agency_id
                state.token = key.token
                state.loginStatus = true
                state.MyuserInfo = key.userInfo
                if (key.agencyOrderRemind.length != 0) {
                    state.oderFlag = key.agencyOrderRemind
                }
            }
            return state, key
        },
        outLogin(state) {
            state.agency_id = null
            state.token = null
            state.loginStatus = false
        },
        // 资料下载列表传输
        fileStatus(state, item) {
            state.fileList = item
        },
        // 课程赠送列表传输
        giveClass(state, item) {
            state.giveClassList = item
        }
    },
    actions: {
        // 页面滑动函数
        asyncScrollToTop(context) {
            context.commit('scrollToTop')
        },
        // 判断用户是否登录
        ifLogin(context, that) {
            console.log("运行了登录判函数")
            if (context.state.loginStatus == false) {
                context.commit('openMessage', {
                    content: '请登录之后再操作',
                    title: '提示',
                    that: that
                })
                return false
            }
            return true
        }
    }
})